var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ws-backdrop',{attrs:{"active":_vm.editBackdropActive && _vm.editMode}},[_c('sidebar-layout-item',{staticClass:"cmp-order-process-item done ws-hover-width-trigger",class:{
      editing: _vm.editMode,
    }},[(!_vm.editMode && !_vm.readOnly)?_c('ws-edit',{staticClass:"float-right",attrs:{"name":"edit","small":_vm.mobile},nativeOn:{"click":function($event){return _vm.setEditMode(_vm.step)}}}):_vm._e(),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }